import resume from '../assets/pdf/sachin-resume.pdf'
import image from '../assets/jpg/sachin_profile.jpg'

export const headerData = {
    name: 'Sachin Dhakal',
    title: "Novice Flutter Developer",
    desciption:"A highly motivated and enthusiastic Software Engineer with over 3+ years of experience in creating and deploying mobile applications. Proficient in Flutter development, with a strong understanding of the Dart programming language. Possess excellent problem-solving skills, an eye for detail, and the ability to work efficiently as part of a team or individually. ",
    image: image,
    resumePdf: resume
}
